export default "__VITE_ASSET__BiXgC_pL__"